import { render, staticRenderFns } from "./CoreValuesTwoIcon.vue?vue&type=template&id=5845b6c7&"
import script from "./CoreValuesTwoIcon.vue?vue&type=script&lang=js&"
export * from "./CoreValuesTwoIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports